import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1e9a1212"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "outBox"
};
const _hoisted_2 = {
  class: "content-box-out"
};
const _hoisted_3 = {
  class: "content-box"
};
const _hoisted_4 = {
  class: "top"
};
const _hoisted_5 = {
  class: "top_left"
};
const _hoisted_6 = {
  class: "shipments"
};
const _hoisted_7 = {
  class: "selectBox"
};
const _hoisted_8 = {
  class: "areaBox"
};
const _hoisted_9 = {
  key: 0,
  class: "areaBox"
};
const _hoisted_10 = {
  key: 1,
  class: "areaBox"
};
const _hoisted_11 = {
  key: 2,
  class: "areaBox"
};
const _hoisted_12 = {
  class: "areaBox"
};
const _hoisted_13 = {
  class: "areaBox"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "areaBox"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "tip",
  style: {
    "background": "#b45a5a"
  }
}, "未审核"), /*#__PURE__*/_createElementVNode("div", {
  class: "tip",
  style: {
    "background": "#dfb229"
  }
}, " 部分审核 "), /*#__PURE__*/_createElementVNode("div", {
  class: "tip",
  style: {
    "background": "#5ab46b"
  }
}, "已审核")], -1));
const _hoisted_15 = {
  class: "btnBox"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预约信息上传", -1));
const _hoisted_17 = {
  class: "upload-box"
};
const _hoisted_18 = {
  class: "upload-box-title"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "upload-box-title-text"
}, "预约信息上传", -1));
const _hoisted_20 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "浏览", -1));
const _hoisted_22 = {
  class: "upload-box-dashed"
};
const _hoisted_23 = {
  class: "upload-icon-group-box"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createElementVNode("div", null, "点击或者拖动文件到虚线框内上传"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "12px"
  }
}, " 支持xls，xlsx类型的文件 ")], -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "导出", -1));
const _hoisted_26 = {
  class: "progressBox"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "30px",
    "color": "#777",
    "font-size": "16.5"
  }
}, "总进度", -1));
const _hoisted_28 = {
  class: "insTableBox"
};
const _hoisted_29 = {
  class: "rowBox"
};
const _hoisted_30 = {
  class: "expand-wrapper",
  style: {
    "box-shadow": "1px 2px 2px 1px #dedede"
  }
};
const _hoisted_31 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自主安装", -1));
const _hoisted_33 = {
  class: "TipsBox"
};
const _hoisted_34 = {
  class: "tipsPopover"
};
const _hoisted_35 = {
  class: "_title"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "供应商信息", -1));
const _hoisted_37 = {
  class: "info"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系人：", -1));
const _hoisted_39 = {
  class: "info"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电话：", -1));
const _hoisted_41 = {
  key: 0
};
const _hoisted_42 = {
  class: "TipsBox"
};
const _hoisted_43 = {
  class: "tipsPopover"
};
const _hoisted_44 = {
  class: "_title"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "验收信息", -1));
const _hoisted_46 = {
  class: "info"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系人", -1));
const _hoisted_48 = {
  class: "info"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电话：", -1));
const _hoisted_50 = {
  class: "info"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "签名图片：", -1));
const _hoisted_52 = {
  style: {
    "width": "100%",
    "height": "200px",
    "background": "#fff"
  }
};
const _hoisted_53 = {
  key: 1
};
const _hoisted_54 = {
  class: "TipsBox"
};
const _hoisted_55 = {
  class: "installation-progress"
};
const _hoisted_56 = ["onClick"];
const _hoisted_57 = {
  key: 1,
  style: {
    "color": "#777",
    "cursor": "not-allowed",
    "font-weight": "400"
  }
};
const _hoisted_58 = {
  class: "bottom-pagination-box"
};
const _hoisted_59 = {
  class: "content-box"
};
const _hoisted_60 = {
  class: "top"
};
const _hoisted_61 = {
  class: "top_left"
};
const _hoisted_62 = {
  class: "shipments"
};
const _hoisted_63 = {
  class: "selectBox"
};
const _hoisted_64 = {
  class: "areaBox"
};
const _hoisted_65 = {
  class: "areaBox"
};
const _hoisted_66 = {
  class: "areaBox"
};
const _hoisted_67 = {
  class: "areaBox"
};
const _hoisted_68 = {
  class: "areaBox"
};
const _hoisted_69 = {
  class: "btnBox"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "物流表上传", -1));
const _hoisted_71 = {
  class: "upload-box"
};
const _hoisted_72 = {
  class: "upload-box-title"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "upload-box-title-text"
}, "物流表上传", -1));
const _hoisted_74 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "浏览", -1));
const _hoisted_76 = {
  class: "upload-box-dashed"
};
const _hoisted_77 = {
  class: "upload-icon-group-box"
};
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__text"
}, [/*#__PURE__*/_createElementVNode("div", null, "点击或者拖动文件到虚线框内上传"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "12px"
  }
}, " 支持xls，xlsx类型的文件 ")], -1));
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "导出", -1));
const _hoisted_80 = {
  class: "progressBox"
};
const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "30px",
    "color": "#777",
    "font-size": "16.5"
  }
}, "总进度", -1));
const _hoisted_82 = {
  class: "insTableBox"
};
const _hoisted_83 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_84 = {
  class: "TipsBox"
};
const _hoisted_85 = {
  class: "tipsPopover"
};
const _hoisted_86 = {
  class: "_title"
};
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "供应商信息", -1));
const _hoisted_88 = {
  class: "info"
};
const _hoisted_89 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系人：", -1));
const _hoisted_90 = {
  class: "info"
};
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电话：", -1));
const _hoisted_92 = {
  class: "TipsBox"
};
const _hoisted_93 = {
  class: "tipsPopover"
};
const _hoisted_94 = {
  class: "_title"
};
const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "收货信息", -1));
const _hoisted_96 = {
  class: "info"
};
const _hoisted_97 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "联系人：", -1));
const _hoisted_98 = {
  class: "info"
};
const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电话：", -1));
const _hoisted_100 = {
  key: 0,
  class: "info"
};
const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "车牌：", -1));
const _hoisted_102 = {
  key: 0
};
const _hoisted_103 = ["onClick"];
const _hoisted_104 = {
  key: 0
};
const _hoisted_105 = {
  key: 1
};
const _hoisted_106 = {
  key: 2
};
const _hoisted_107 = {
  key: 1
};
const _hoisted_108 = {
  class: "TipsBox"
};
const _hoisted_109 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString("在途中"), -1));
const _hoisted_110 = {
  class: "tipsPopover3"
};
const _hoisted_111 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已送达", -1));
const _hoisted_112 = {
  key: 1
};
const _hoisted_113 = {
  class: "bottom-pagination-box"
};
const _hoisted_114 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ex-dialog-title"
}, "导入校验错误", -1));
const _hoisted_115 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "overflow-y": "auto"
  }
};
const _hoisted_116 = {
  style: {
    "display": "flex",
    "justify-content": "end",
    "padding": "10px 0px"
  }
};
const _hoisted_117 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "关闭", -1));
const _hoisted_118 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "100%"
  }
};
const _hoisted_119 = {
  key: 0,
  id: "container"
};
const _hoisted_120 = {
  key: 1,
  id: "panel",
  style: {
    "width": "100%",
    "height": "200px"
  }
};
const _hoisted_121 = {
  key: 2,
  class: "tipsPopover1"
};
const _hoisted_122 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_123 = {
  style: {
    "min-width": "135px"
  }
};
const _hoisted_124 = {
  style: {
    "min-width": "50px",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_125 = {
  style: {
    "width": "1px",
    "background-color": "#777777",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_126 = {
  key: 0,
  style: {
    "min-width": "12px",
    "height": "12px",
    "background-color": "white",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_127 = {
  key: 1,
  style: {
    "min-width": "8px",
    "height": "8px",
    "background-color": "white",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_128 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "6px",
    "height": "6px",
    "background-color": "#777777",
    "border-radius": "50%"
  }
}, null, -1));
const _hoisted_129 = [_hoisted_128];
const _hoisted_130 = {
  style: {
    "margin-bottom": "10px",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_131 = {
  key: 0,
  style: {
    "font-size": "14px",
    "color": "black"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_down_circle_outlined = _resolveComponent("down-circle-outlined");
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_cascader = _resolveComponent("a-cascader");
  const _component_a_input_search = _resolveComponent("a-input-search");
  const _component_a_button = _resolveComponent("a-button");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_a_progress = _resolveComponent("a-progress");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_link = _resolveComponent("el-link");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_vxe_pager = _resolveComponent("vxe-pager");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_ex_dialog = _resolveComponent("ex-dialog");
  const _component_a_modal = _resolveComponent("a-modal");
  const _component_a_config_provider = _resolveComponent("a-config-provider");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_tabs, {
    activeKey: $setup.activeName,
    "onUpdate:activeKey": _cache[23] || (_cache[23] = $event => $setup.activeName = $event),
    type: "line",
    class: "tabs-card default-tabs",
    tabBarStyle: {
      background: '#f7f8ff'
    },
    animated: false
  }, {
    default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
      key: "first",
      tab: "安装及确认进度"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.storeType,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.installQuery.insSelect.storeType = $event),
        placeholder: "选择店铺类型",
        size: "medium",
        onChange: _cache[1] || (_cache[1] = $event => $setup.searchInstallClick(1)),
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeTypeInstallationData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.storeTypeId,
            value: item.storeTypeId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.storeTypeNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value"])]), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_a_select, {
        disabled: $setup.vendorId.length > 0,
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.vendorId,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => $setup.installQuery.insSelect.vendorId = $event),
        placeholder: "选择供应商",
        size: "medium",
        onChange: $setup.searchInstallClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vendorData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.vendorId,
            value: item.vendorId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vendorName), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["disabled", "value", "onChange"])])) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.vendorTypeId,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => $setup.installQuery.insSelect.vendorTypeId = $event),
        placeholder: "选择服务内容",
        size: "medium",
        onChange: $setup.searchInstallClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vendorTypeData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.vendor,
            value: item.vendorTypeId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vendorTypeNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "onChange"])])) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.installationStatusId,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => $setup.installQuery.insSelect.installationStatusId = $event),
        placeholder: "选择安装状态",
        size: "medium",
        onChange: $setup.searchInstallClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.installationStatusData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.installationStatusId,
            value: item.installationStatusId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.installationStatusNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "onChange"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createVNode(_component_a_cascader, {
        style: {
          "width": "150px"
        },
        value: $setup.installQuery.insSelect.provinceCity,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => $setup.installQuery.insSelect.provinceCity = $event),
        options: $setup.provinceDictData,
        placeholder: "选择城市",
        changeOnSelect: true,
        "expand-trigger": "hover",
        onChange: _cache[6] || (_cache[6] = $event => $setup.searchInstallClick(2))
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        _: 1
      }, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.installationConfirmStatusId,
        "onUpdate:value": _cache[7] || (_cache[7] = $event => $setup.installQuery.insSelect.installationConfirmStatusId = $event),
        placeholder: "选择审核状态",
        size: "medium",
        onChange: $setup.searchInstallClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [_createVNode(_component_a_select_option, {
          value: "1"
        }, {
          default: _withCtx(() => [_createTextVNode("未审核")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "2"
        }, {
          default: _withCtx(() => [_createTextVNode("部分审核")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "3"
        }, {
          default: _withCtx(() => [_createTextVNode("已审核")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value", "onChange"])]), _hoisted_14]), _createElementVNode("div", null, [_createVNode(_component_a_input_search, {
        value: $setup.installQuery.insValue,
        "onUpdate:value": _cache[8] || (_cache[8] = $event => $setup.installQuery.insValue = $event),
        placeholder: "搜索内容",
        style: {
          "width": "264px"
        },
        onSearch: $setup.searchInstallClick
      }, null, 8, ["value", "onSearch"])])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
        visible: $setup.uploadInstallPopoverVisible,
        placement: "bottom",
        trigger: "click",
        width: "auto",
        teleported: false,
        "popper-class": "upload-box-popper"
      }, {
        reference: _withCtx(() => [$setup.permission.havePermission('安装及发货进度', '预约信息上传') ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          class: "sts-button default",
          color: "black",
          onClick: $setup.openUploadInstallPopover,
          style: {
            "width": "100px"
          }
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createVNode(_component_svg_icon, {
          iconName: "close",
          iconColor: 'black',
          iconSize: "15px",
          style: {
            "cursor": "pointer",
            "padding": "3px"
          },
          onClick: _cache[9] || (_cache[9] = $event => $setup.uploadInstallPopoverVisible = false)
        })]), _createVNode(_component_el_upload, {
          "on-exceed": $setup.handleInstallExceed,
          class: "upload-pane",
          drag: "",
          ref: "uploadInstallPane",
          action: $setup.uploadInstallData.signatureData.host,
          "before-upload": $setup.handleInstallBeforeUpload,
          "on-success": $setup.handleInstallOnSuccess,
          data: $setup.uploadInstallData.data,
          limit: 1,
          "file-list": $setup.uploadInstallData.fileList
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_a_button, {
            class: "sts-button default",
            color: "#539ce0",
            style: {
              "width": "100px",
              "margin": "5px 0px"
            }
          }, {
            default: _withCtx(() => [_hoisted_21]),
            _: 1
          }), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(_component_svg_icon, {
            iconName: "Excel",
            iconSize: "18px"
          }), _createVNode(_component_svg_icon, {
            iconName: "upload",
            iconSize: "18px"
          })]), _hoisted_24])])]),
          _: 1
        }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
        _: 1
      }, 8, ["visible"]), $setup.permission.havePermission('安装及发货进度', '安装进度导出') ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        class: "sts-button default",
        color: "black",
        style: {
          "margin-right": "15px"
        },
        onClick: $setup.openInstallationEvent
      }, {
        default: _withCtx(() => [_hoisted_25]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createVNode(_component_a_progress, {
        "stroke-color": {
          '0%': '#447ae2',
          '100%': '#29abe2'
        },
        percent: $setup.installConveyData.install.percentage,
        style: {
          "width": "190px",
          "height": "15px"
        },
        trailColor: "#f0f0f0"
      }, null, 8, ["percent"])])])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_vxe_table, {
        size: "medium",
        class: "column-sort",
        ref: "installTable",
        height: "auto",
        stripe: "",
        data: $setup.installationData.data,
        "row-config": {
          useKey: true
        },
        loading: $setup.installLoading,
        "loading-config": {
          icon: 'vxe-icon-indicator roll',
          text: ' '
        },
        "column-config": {
          useKey: true
        },
        "sort-config": {
          showIcon: false
        },
        onHeaderCellClick: $setup.headerCellInstallClickEvent,
        onScroll: $setup.installTableScroll,
        "expand-config": $setup.expandConfig,
        "row-class-name": $setup.rowClassName
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          field: "storeName",
          type: "expand",
          title: "店铺名称",
          "min-width": !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 350 : 450,
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.storeName), 1)]),
          content: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_vxe_table, {
            style: {
              "max-width": "100%"
            },
            "show-header": false,
            data: row.storeLocations
          }, {
            default: _withCtx(() => [_createVNode(_component_vxe_column, {
              width: "100",
              field: "installationStatusNameZh"
            }), $setup.vendorId == '' && $setup.tokenData.type === 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
              key: 0,
              width: "50",
              field: "vendorName"
            })) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
              width: "50",
              field: "storeFloor"
            }), _createVNode(_component_vxe_column, {
              width: "150",
              field: "category"
            }), _createVNode(_component_vxe_column, {
              width: "100",
              field: "region"
            }), _createVNode(_component_vxe_column, {
              width: "100",
              field: "gender"
            }), _createVNode(_component_vxe_column, {
              width: "200",
              field: "supportType"
            }), _createVNode(_component_vxe_column, {
              width: "60",
              field: "ice"
            }), _createVNode(_component_vxe_column, {
              width: "100",
              field: "location"
            }), _createVNode(_component_vxe_column, {
              width: "200",
              field: "locationSummary"
            }), _createVNode(_component_vxe_column, {
              width: "200",
              field: "locationDescription"
            }), _createVNode(_component_vxe_column, {
              width: "170"
            }, {
              default: _withCtx(({
                row: subRow
              }) => [_createElementVNode("div", _hoisted_31, [subRow.installationStatusId == 1 && $setup.tokenData.type == 2 && $setup.tokenData.managerId == subRow.vendorId ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                onClick: $event => $setup.selfActivityInstallation(row, subRow),
                class: "sts-button default",
                style: {
                  "height": "28px",
                  "padding": "0",
                  "width": "50px"
                }
              }, {
                default: _withCtx(() => [_hoisted_32]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["data"])])])]),
          _: 1
        }, 8, ["min-width"]), _createVNode(_component_vxe_column, {
          field: "storeTypeId",
          title: "店铺类型",
          width: !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 150 : 250,
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.storeTypeNameZh), 1)]),
          _: 1
        }, 8, ["width"]), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 0,
          field: "vendorName",
          title: "供应商",
          width: !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 100 : 200,
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: false,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createElementVNode("span", null, _toDisplayString(row.vendorName), 1), _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "Tips",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_hoisted_36, _createVNode(_component_svg_icon, {
              iconName: "copy",
              iconSize: "18px",
              onClick: $event => $setup.copyVendor(row)
            }, null, 8, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.activityInstallations, (install, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, [_createElementVNode("div", _hoisted_37, [_hoisted_38, _createElementVNode("p", null, _toDisplayString(install.installationResponsibleName), 1)]), _createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("p", null, _toDisplayString(install.phoneNumber), 1)])]);
            }), 128))])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])]),
          _: 1
        }, 8, ["width"])) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 1,
          field: "vendorTypeId",
          title: "服务内容",
          "min-width": "100",
          width: 100,
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.vendorTypeNameZh), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
          field: "city",
          title: "城市",
          "min-width": "100",
          width: 100,
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          _: 1
        }), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 2,
          field: "installationStatusId",
          title: "店员验收状态",
          width: "150",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [row.installationStatusId === 5 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createVNode(_component_el_popover, {
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: true,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createElementVNode("span", null, _toDisplayString(row.installationStatusNameZh), 1), _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "Tips",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_hoisted_45, _createVNode(_component_svg_icon, {
              iconName: "copy",
              iconSize: "18px",
              onClick: $event => $setup.copyResult(row)
            }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_46, [_hoisted_47, _createElementVNode("p", null, _toDisplayString(row.installationResultContactName ? row.installationResultContactName : "暂无"), 1)]), _createElementVNode("div", _hoisted_48, [_hoisted_49, _createElementVNode("p", null, _toDisplayString(row.installationResultContactMobile), 1)]), _createElementVNode("div", _hoisted_50, [_hoisted_51, _createElementVNode("div", _hoisted_52, [_createVNode(_component_el_image, {
              src: row.installationAcceptanceSign ? row.installationAcceptanceSign : row.uploadedName,
              alt: "",
              style: {
                "width": "100%",
                "border": "1px solid red",
                "height": "200px",
                "background": "#fff"
              }
            }, null, 8, ["src"])])])])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])) : (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", null, _toDisplayString(row.installationStatusNameZh), 1)])]))]),
          _: 1
        })) : _createCommentVNode("", true), $setup.vendorId == '' && $setup.tokenData.type === 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 3,
          field: "installationConfirmStatusNameCn",
          title: "安装进度",
          width: "200",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", null, _toDisplayString(row.installationProgress) + "%", 1), _createVNode(_component_el_progress, {
            style: {
              "width": "118px"
            },
            "show-text": false,
            "stroke-width": 6,
            percentage: row.installationProgress,
            color: "black"
          }, null, 8, ["percentage"])])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
          field: "",
          title: "安装照片",
          width: !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 120 : 250,
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
          default: _withCtx(({
            row
          }) => [row.imageUrl != null ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: $event => $setup.installUploadClick(row),
            style: {
              "color": "#0763db",
              "cursor": "pointer",
              "font-weight": "400"
            }
          }, " 查看 ", 8, _hoisted_56)) : (_openBlock(), _createElementBlock("span", _hoisted_57, " 查看 "))]),
          _: 1
        }, 8, ["width"]), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 4,
          field: "installationConfirmStatusNameCn",
          title: "供应商审核状态",
          width: "150",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.installationConfirmStatusNameCn), 1)]),
          _: 1
        })) : _createCommentVNode("", true), $setup.vendorId == '' && $setup.tokenData.type === 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 5,
          field: "installationConfirmStatusNameCn",
          title: "审核状态",
          sortable: "",
          "min-width": "120"
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          _: 1
        })) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 6,
          field: "",
          title: "预约状态",
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.installationDate ? "已预约" : "未预约"), 1)]),
          _: 1
        })) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 7,
          field: "installationDate",
          title: "预约时间",
          "min-width": "200",
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.installationDate ? $setup.getDate(row.installationDate) : "未预约"), 1)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data", "loading", "onHeaderCellClick", "onScroll", "expand-config", "row-class-name"])]), _createElementVNode("div", _hoisted_58, [_createVNode(_component_vxe_pager, {
        class: "sts-pager",
        background: "",
        "page-size": $setup.installPaginationData.pageSize,
        "onUpdate:pageSize": _cache[10] || (_cache[10] = $event => $setup.installPaginationData.pageSize = $event),
        "current-page": $setup.installPaginationData.currentPage,
        "onUpdate:currentPage": _cache[11] || (_cache[11] = $event => $setup.installPaginationData.currentPage = $event),
        "pager-count": 5,
        total: $setup.installPaginationData.totalSize,
        "page-sizes": $setup.installPaginationData.pageSizes,
        layouts: ['PrevJump', 'JumpNumber', 'NextJump', 'Sizes', 'FullJump', 'Total'],
        onPageChange: $setup.paginationCurrentInstallChange
      }, null, 8, ["page-size", "current-page", "total", "page-sizes", "onPageChange"])])])]),
      _: 1
    }), _createVNode(_component_a_tab_pane, {
      key: "second",
      tab: "发货及送达进度"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.storeType,
        "onUpdate:value": _cache[12] || (_cache[12] = $event => $setup.conveyQuery.insSelect.storeType = $event),
        placeholder: "选择店铺类型",
        size: "medium",
        onChange: _cache[13] || (_cache[13] = $event => $setup.searchConverClick(1)),
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeTypeLogisticsData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.storeTypeId,
            value: item.storeTypeId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.storeTypeNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value"])]), _createElementVNode("div", _hoisted_65, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.state,
        "onUpdate:value": _cache[14] || (_cache[14] = $event => $setup.conveyQuery.insSelect.state = $event),
        placeholder: "选择物流状态",
        size: "medium",
        onChange: $setup.searchConverClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [_createVNode(_component_a_select_option, {
          value: "0"
        }, {
          default: _withCtx(() => [_createTextVNode("在途中")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "3"
        }, {
          default: _withCtx(() => [_createTextVNode("已签收")]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "4"
        }, {
          default: _withCtx(() => [_createTextVNode("问题件")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value", "onChange"])]), _createElementVNode("div", _hoisted_66, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.logisticsTypeId,
        "onUpdate:value": _cache[15] || (_cache[15] = $event => $setup.conveyQuery.insSelect.logisticsTypeId = $event),
        placeholder: "选择物流分类",
        size: "medium",
        onChange: $setup.searchConverClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.logisticsTypeData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.logisticsTypeId,
            value: item.logisticsTypeId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.logisticsTypeNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "onChange"])]), _createElementVNode("div", _hoisted_67, [_createVNode(_component_a_select, {
        disabled: $setup.vendorId.length > 0,
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.vendorId,
        "onUpdate:value": _cache[16] || (_cache[16] = $event => $setup.conveyQuery.insSelect.vendorId = $event),
        placeholder: "选择供应商",
        size: "medium",
        onChange: $setup.searchConverClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vendorData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.vendorId,
            value: item.vendorId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vendorName), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["disabled", "value", "onChange"])]), _createElementVNode("div", _hoisted_68, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.areaInput,
        "onUpdate:value": _cache[17] || (_cache[17] = $event => $setup.conveyQuery.insSelect.areaInput = $event),
        placeholder: "选择城市",
        size: "medium",
        onChange: _cache[18] || (_cache[18] = $event => $setup.searchConverClick(2)),
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cityData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item,
            value: item
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value"])])]), _createElementVNode("div", null, [_createVNode(_component_a_input_search, {
        value: $setup.conveyQuery.insValue,
        "onUpdate:value": _cache[19] || (_cache[19] = $event => $setup.conveyQuery.insValue = $event),
        placeholder: "搜索内容",
        style: {
          "width": "264px"
        },
        onSearch: $setup.searchConverClick
      }, null, 8, ["value", "onSearch"])])])]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
        visible: $setup.uploadConverPopoverVisible,
        placement: "bottom",
        trigger: "click",
        width: "auto",
        teleported: false,
        "popper-class": "upload-box-popper"
      }, {
        reference: _withCtx(() => [$setup.permission.havePermission('安装及发货进度', '物流表上传') ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          class: "sts-button default",
          color: "black",
          onClick: $setup.openUploadConverPopover,
          style: {
            "margin-right": "15px"
          }
        }, {
          default: _withCtx(() => [_hoisted_70]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_hoisted_73, _createVNode(_component_svg_icon, {
          iconName: "close",
          iconColor: 'black',
          iconSize: "15px",
          style: {
            "cursor": "pointer",
            "padding": "3px"
          },
          onClick: _cache[20] || (_cache[20] = $event => $setup.uploadConverPopoverVisible = false)
        })]), _createVNode(_component_el_upload, {
          "on-exceed": $setup.handleConverExceed,
          class: "upload-pane",
          drag: "",
          ref: "uploadConverPane",
          action: $setup.uploadConverData.signatureData.host,
          "before-upload": $setup.handleConverBeforeUpload,
          "on-success": $setup.handleConverOnSuccess,
          data: $setup.uploadConverData.data,
          limit: 1,
          "file-list": $setup.uploadConverData.fileList
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_74, [_createVNode(_component_a_button, {
            class: "sts-button default",
            color: "#539ce0",
            style: {
              "width": "100px",
              "margin": "5px 0px"
            }
          }, {
            default: _withCtx(() => [_hoisted_75]),
            _: 1
          }), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createVNode(_component_svg_icon, {
            iconName: "Excel",
            iconSize: "18px"
          }), _createVNode(_component_svg_icon, {
            iconName: "upload",
            iconSize: "18px"
          })]), _hoisted_78])])]),
          _: 1
        }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
        _: 1
      }, 8, ["visible"]), $setup.permission.havePermission('安装及发货进度', '物流表导出') ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        class: "sts-button default",
        color: "black",
        style: {
          "margin-right": "15px"
        },
        onClick: $setup.openExportEvent
      }, {
        default: _withCtx(() => [_hoisted_79]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
        class: "sts-button default",
        color: "black",
        style: {
          "margin-right": "15px"
        },
        onClick: $setup.batchDeliveredLogistics
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($setup.deliveredControl.isOpenBatch == false ? "批量送达" : "确认送达"), 1)]),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_80, [_hoisted_81, _createVNode(_component_a_progress, {
        "stroke-color": {
          '0%': '#447ae2',
          '100%': '#29abe2'
        },
        percent: $setup.installConveyData.convey.percentage,
        style: {
          "width": "190px",
          "height": "15px"
        },
        trailColor: "#f0f0f0"
      }, null, 8, ["percent"])])])]), _createElementVNode("div", _hoisted_82, [_createVNode(_component_vxe_table, {
        size: "medium",
        class: "column-sort",
        ref: "conveyTable",
        stripe: "",
        "export-config": {},
        height: "auto",
        data: $setup.conveyData.data,
        "row-config": {
          useKey: true
        },
        loading: $setup.conveyLoading,
        "loading-config": {
          icon: 'vxe-icon-indicator roll',
          text: ' '
        },
        "column-config": {
          useKey: true
        },
        "sort-config": {
          showIcon: false
        },
        onHeaderCellClick: $setup.headerCellConverClickEvent,
        onScroll: $setup.conveyTableScroll,
        "checkbox-config": $setup.checkboxConfig
      }, {
        default: _withCtx(() => [_createTextVNode(" > "), $setup.deliveredControl.isOpenBatch == true ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 0,
          type: "checkbox"
        })) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
          field: "storeName",
          title: "店铺名称",
          "min-width": !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 350 : 450,
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", _hoisted_83, _toDisplayString(row.storeName), 1)]),
          _: 1
        }, 8, ["min-width"]), _createVNode(_component_vxe_column, {
          field: "storeTypeId",
          title: "店铺类型",
          width: "200",
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.storeTypeNameZh), 1)]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "vendorName",
          title: "供应商",
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: false,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_84, [_createElementVNode("span", null, _toDisplayString(row.vendorName), 1), _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "Tips",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_hoisted_87, _createVNode(_component_svg_icon, {
              iconName: "copy",
              iconSize: "18px",
              onClick: $event => $setup.copyVendor(row)
            }, null, 8, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.activityInstallations, (install, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, [_createElementVNode("div", _hoisted_88, [_hoisted_89, _createElementVNode("p", null, _toDisplayString(install.installationResponsibleName), 1)]), _createElementVNode("div", _hoisted_90, [_hoisted_91, _createElementVNode("p", null, _toDisplayString(install.phoneNumber), 1)])]);
            }), 128))])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "vendorTypeId",
          title: "服务内容",
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.vendorTypeNameZh), 1)]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "city",
          title: "城市",
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "logisticsTypeNameZh",
          title: "物流分类",
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.logisticsTypeNameZh), 1)]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "logisticsOrderCode",
          title: "物流信息",
          "min-width": "180",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: true,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_92, [_createElementVNode("span", null, _toDisplayString(row.logisticsOrderCode), 1), _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "Tips",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_hoisted_95, _createVNode(_component_svg_icon, {
              iconName: "copy",
              iconSize: "18px",
              onClick: $event => $setup.copyVendor(row)
            }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_96, [_hoisted_97, _createElementVNode("p", null, _toDisplayString(row.contacts), 1)]), _createElementVNode("div", _hoisted_98, [_hoisted_99, _createElementVNode("p", null, _toDisplayString(row.phoneNumber), 1)]), row.logisticsTypeNameZh !== '物流' ? (_openBlock(), _createElementBlock("div", _hoisted_100, [_hoisted_101, _createElementVNode("p", null, _toDisplayString(row.logisticsOrderCode), 1)])) : _createCommentVNode("", true)])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "expressStateName",
          title: "物流状态",
          "min-width": "150",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [row.logisticsTypeNameZh === '物流' ? (_openBlock(), _createElementBlock("div", _hoisted_102, [_createElementVNode("div", {
            onClick: $event => $setup.onExpressInfoOpen(row),
            class: "TipsBox"
          }, [row.expressStateId.substring(0, 1) === '3' ? (_openBlock(), _createElementBlock("span", _hoisted_104, "已签收")) : _createCommentVNode("", true), row.expressStateId.substring(0, 1) === '4' ? (_openBlock(), _createElementBlock("span", _hoisted_105, "问题件")) : _createCommentVNode("", true), row.expressStateId.substring(0, 1) !== '3' && row.expressStateId.substring(0, 1) !== '4' ? (_openBlock(), _createElementBlock("span", _hoisted_106, "在途中")) : _createCommentVNode("", true), _createVNode(_component_svg_icon, {
            class: "tip",
            iconName: "unfold",
            iconSize: "15px",
            style: {
              "cursor": "pointer"
            }
          })], 8, _hoisted_103)])) : (_openBlock(), _createElementBlock("div", _hoisted_107, [row.expressStateName !== '已签收' && ($setup.tokenData.type === 1 || $setup.tokenData.type === 2 && $setup.tokenData.managerId === row.vendorId) ? (_openBlock(), _createBlock(_component_el_popover, {
            key: 0,
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: true,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_108, [_hoisted_109, _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "unfold",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_110, [_createVNode(_component_a_button, {
              class: "sts-button default",
              color: "black",
              style: {
                "margin": "5px 0"
              },
              onClick: $event => $setup.deliveredLogistics(row)
            }, {
              default: _withCtx(() => [_hoisted_111]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), row.expressStateName == '已签收' ? (_openBlock(), _createElementBlock("div", _hoisted_112, "已送达")) : _createCommentVNode("", true)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "loading", "onHeaderCellClick", "onScroll", "checkbox-config"])]), _createElementVNode("div", _hoisted_113, [_createVNode(_component_vxe_pager, {
        class: "sts-pager",
        background: "",
        "page-size": $setup.conveyPaginationData.pageSize,
        "onUpdate:pageSize": _cache[21] || (_cache[21] = $event => $setup.conveyPaginationData.pageSize = $event),
        "current-page": $setup.conveyPaginationData.currentPage,
        "onUpdate:currentPage": _cache[22] || (_cache[22] = $event => $setup.conveyPaginationData.currentPage = $event),
        "pager-count": 5,
        total: $setup.conveyPaginationData.totalSize,
        "page-sizes": $setup.conveyPaginationData.pageSizes,
        layouts: ['PrevJump', 'JumpNumber', 'NextJump', 'Sizes', 'FullJump', 'Total'],
        onPageChange: $setup.paginationCurrentConverChange
      }, null, 8, ["page-size", "current-page", "total", "page-sizes", "onPageChange"])])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["activeKey"])])]), _createVNode(_component_ex_dialog, {
    extraStyle: "min-width: 380px;\n    max-width: 600px;\n    width: 80%;\n    height: 400px;\n    font-size: 14px;\n    padding:10px",
    isVisible: $setup.importMessage.importMessageVisible
  }, {
    default: _withCtx(() => [_hoisted_114, _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_115, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.importMessage.importMessages, (message, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index
      }, _toDisplayString(message), 1);
    }), 128))]), _createElementVNode("div", _hoisted_116, [_createVNode(_component_a_button, {
      onClick: _cache[24] || (_cache[24] = $event => $setup.importMessage.importMessageVisible = false),
      style: {
        "border-color": "black",
        "color": "black"
      },
      class: "sts-button default"
    }, {
      default: _withCtx(() => [_hoisted_117]),
      _: 1
    })])]),
    _: 1
  }, 8, ["isVisible"]), _createVNode(_component_a_config_provider, {
    theme: {
      components: {
        Modal: {
          paddingContentHorizontalLG: 12,
          paddingMD: 12
        }
      }
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_a_modal, {
      open: $setup.expressInfoOpen,
      "onUpdate:open": _cache[25] || (_cache[25] = $event => $setup.expressInfoOpen = $event),
      closable: false,
      width: "704px",
      zIndex: 1001,
      centered: true,
      footer: null,
      title: null
    }, {
      default: _withCtx(() => [_createVNode(_component_svg_icon, {
        onClick: $setup.onExpressInfoClose,
        class: "tip",
        iconName: "close_circle",
        iconSize: "20px",
        iconColor: '#ffffff',
        style: {
          "cursor": "pointer",
          "position": "absolute",
          "top": "-20px",
          "right": "-40px"
        }
      }, null, 8, ["onClick"]), _createElementVNode("div", _hoisted_118, [$setup.currentExpress && $setup.currentExpress.expressCoordinates != null && $setup.currentExpress.expressCoordinates.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_119)) : _createCommentVNode("", true), $setup.currentExpress && $setup.currentExpress.expressCoordinates != null && $setup.currentExpress.expressCoordinates.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_120)) : _createCommentVNode("", true), $setup.currentExpress ? (_openBlock(), _createElementBlock("div", _hoisted_121, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentExpress.expressTraces.slice().reverse(), (x, index) => {
        return _openBlock(), _createElementBlock("div", {
          style: {
            "display": "flex",
            "color": "#777777"
          },
          key: index
        }, [_createElementVNode("div", _hoisted_122, [_createElementVNode("div", _hoisted_123, _toDisplayString(x.expressTraceAcceptTime), 1), _createElementVNode("div", _hoisted_124, [_createElementVNode("div", _hoisted_125, [index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_126, [_createVNode(_component_svg_icon, {
          iconName: "confirm",
          iconColor: 'red',
          iconSize: "12px"
        })])) : _createCommentVNode("", true), index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_127, _hoisted_129)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_130, [index === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_131, _toDisplayString($setup.currentExpress.expressStateName), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(x.expressTraceAcceptStation), 1)])])]);
      }), 128))])) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["open"])]),
    _: 1
  })], 64);
}